export default "__VITE_ASSET__DA6G7SPd__"